<script setup lang="ts">

import { AssetTypeId } from '../fin/assets';
import { RetirementConfig } from '../fin/retirement_config';
import { ref, watch } from 'vue';

interface Props {
  config: RetirementConfig|null;
}

const { config=null } = defineProps<Props>();

const root = ref();
const defects = ref<string[]>([]);

watch(
  ()=>config,
  (newConfig, _old) => {
    validateConfig(newConfig);
  },
);

function validateConfig(config: RetirementConfig|null): void {
  defects.value = [];
  if (!config) {
    return;
  }
  
  if (config.market.taxed_growth_rate > config.market.untaxed_growth_rate) {
    defects.value.push('Taxed growth rate is greater than untaxed growth rate, which implies negative taxation.');
  }

  if (
    config.strategy.preRetirementSavingsRatesPa.balance(AssetTypeId.ISA) != 20_000 &&
    config.strategy.preRetirementSavingsRatesPa.balance(AssetTypeId.Unprotected) > 0
  ) {
    defects.value.push('Your pre-retirement ISA savings are less than the full allowance of 20,000 but you are simultaneously saving into your unprotected asset pool.');
  }


  if (defects.value.length) {
    root.value?.removeAttribute('hidden');
  } else {
    root.value?.setAttribute('hidden', null);
  }
}

</script>

<template>
  <div class="validation-card" ref="root">
    <h3>Config Validation Problems</h3>
    <ul>
      <li v-for="defect in defects" class="fin-validation-defect">
        {{ defect }}
      </li>
    </ul>
  </div>
</template>

<style scoped>

.validation-card {
  border-color: orange; 
}

.fin-validation-defect {
  color: red;
}

*[hidden] {
  display: none;
}

</style>
